module.exports = __webpack_public_path__ + "img/van-red.711ab966.svg";